import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import { isCapacitorPlatform } from "@utils/specific/capacitor";
import { useTranslation } from "react-i18next";

export const CapacitorUpdate = observer(function CapacitorUpdateExists(props: {
	setIsNavMenuOpen: Function;
}) {
	const { capacitorUpdaterStore } = useRootAppStore();
	const { t } = useTranslation();

	const requestUpdate = () => {
		props.setIsNavMenuOpen(false);
		capacitorUpdaterStore.checkVersionDiff(true);
	};

	if (!isCapacitorPlatform()) {
		return null;
	}

	if (!capacitorUpdaterStore.shouldShowUpdateAvailable) {
		return null;
	}

	return (
		<div className="sidebar__section">
			<nav className="nav--secondary">
				<ul className="nav--secondary__menu">
					<li className="nav--secondary__inner nav--secondary__item--full">
						<span className="nav--secondary__inner u-type--center">
							{t("CAPACITOR_UPDATE.UPDATE_AVAILABLE")}
						</span>
						<button
							className="btn btn--sml btn--block btn--primary"
							onClick={requestUpdate}
						>
							<span className="btn__label">
								{t("CAPACITOR_UPDATE.UPDATE_BTN")}
							</span>
						</button>
					</li>
				</ul>
			</nav>
		</div>
	);
});
